import * as React from "react";
import { UsersIcon, StarIcon } from "@heroicons/react/24/solid";
import { RLink } from "../DesignSystem/RLink";

export function MiyoEasterEggMenu({
  onCloseDropdown,
}: {
  onCloseDropdown: () => void;
}): JSX.Element {
  return (
    <>
      <span className="flex w-full cursor-pointer items-center gap-2 px-4 py-2 text-left text-sm hover:bg-slate-100 dark:hover:bg-white/10">
        <UsersIcon className="h-4 w-4" />
        Learn about distance
      </span>
      <span className="flex w-full cursor-pointer items-center gap-2 px-4 py-2 text-left text-sm hover:bg-slate-100 dark:hover:bg-white/10">
        <span className="flex h-4 w-4 items-center justify-center gap-0.5">
          <span className="h-2 w-2 rounded-full bg-pink-400"></span>
          <span className="h-2 w-2 rounded-full bg-blue-400"></span>
        </span>
        Learn about pink and blue
      </span>
      <span className="flex w-full cursor-pointer items-center gap-2 px-4 py-2 text-left text-sm hover:bg-slate-100 dark:hover:bg-white/10">
        <span className="flex h-4 w-4 items-center justify-center">
          <span className="h-2.5 w-2.5 rounded-full bg-green-400"></span>
        </span>
        Learn about summertime
      </span>
      <RLink
        white
        to="/explain-xp"
        className="flex w-full items-center gap-2 px-4 py-2 text-left text-sm hover:bg-slate-100 hover:no-underline dark:hover:bg-white/10"
        onClick={onCloseDropdown}
      >
        <StarIcon className="h-4 w-4" />
        Learn all about XP
      </RLink>
    </>
  );
}
